import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '@account-services-mfe/core';
import { PaymentSecurityScreens } from '../../../../typings';
import { usePaymentSecurityContext } from '../../../../context';
const PaymentSecurityFooter = ({ currentScreen, handleClose, handleEnrollSubmit }) => {
    const { setErrorOnUpdate, isChecked } = usePaymentSecurityContext();
    const { t } = useTranslation();
    const { showPopup } = usePaymentSecurityContext();
    const DATA_SECONDARY_REASON = 'back to account services';
    const DATA_TYPE = 'payment security';
    const DATA_OBJECT = 'button';
    const BACK_TO_ACCOUNT_SERVICES_TEXT = t('footer.backToAccountServices');
    const MANAGE_PAYMENT_SECURITY_TEXT = t('footer.managePaymentSecurity');
    const handleOnSubmitUnenrolled = () => {
        if (!isChecked) {
            setErrorOnUpdate();
        }
        else {
            handleEnrollSubmit();
        }
    };
    const backToAccountServicesParams = {
        handlePrimaryButton: handleClose,
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_TYPE,
        dataPrimaryReason: DATA_SECONDARY_REASON,
        primaryText: BACK_TO_ACCOUNT_SERVICES_TEXT
    };
    const managePaymentSecurityCommonParams = {
        handlePrimaryButton: showPopup,
        handleSecondaryButton: handleClose,
        primaryText: MANAGE_PAYMENT_SECURITY_TEXT,
        secondaryButtonType: 'ghost',
        secondaryText: BACK_TO_ACCOUNT_SERVICES_TEXT,
        dataSecondaryType: DATA_TYPE,
        dataSecondaryReason: DATA_SECONDARY_REASON,
        dataSecondaryObject: DATA_OBJECT
    };
    const paymentSecurityFooter = {
        [PaymentSecurityScreens.ENROLLED]: {
            ...managePaymentSecurityCommonParams,
            dataPrimaryObject: DATA_OBJECT,
            dataPrimaryReason: 'manage payment security',
            dataPrimaryType: DATA_TYPE
        },
        [PaymentSecurityScreens.CANCELLED]: {
            ...managePaymentSecurityCommonParams,
            dataPrimaryObject: DATA_OBJECT,
            dataPrimaryReason: 'manage payment security',
            dataPrimaryType: DATA_TYPE
        },
        [PaymentSecurityScreens.DENIED_ENROLLMENT]: {
            dataPrimaryObject: DATA_OBJECT,
            dataPrimaryReason: 'close',
            dataPrimaryType: DATA_TYPE,
            handlePrimaryButton: handleClose,
            primaryText: t('footer.close')
        },
        [PaymentSecurityScreens.ENROLLMENT_SUCCESS]: backToAccountServicesParams,
        [PaymentSecurityScreens.DEFAULT]: backToAccountServicesParams,
        [PaymentSecurityScreens.GENERIC_ERROR]: backToAccountServicesParams,
        [PaymentSecurityScreens.PENDING]: backToAccountServicesParams,
        [PaymentSecurityScreens.UNENROLLED]: {
            ...managePaymentSecurityCommonParams,
            handlePrimaryButton: handleOnSubmitUnenrolled,
            primaryText: t('footer.purchasePaymentSecurity'),
            dataPrimaryObject: DATA_OBJECT,
            dataPrimaryReason: 'purchase payment security',
            dataPrimaryType: DATA_TYPE
        }
    };
    return (_jsx(ModalFooter, { "data-testid": "payment-security-footer", ...paymentSecurityFooter[currentScreen] }));
};
export default PaymentSecurityFooter;
